<template>
	<div>
		<!-- 上传图片dialog -->
		<el-dialog title="上传相册图片" :visible.sync="albumDialogShow" width="80%" style="text-align: left;" class="pic-dialog" :append-to-body="appendtobody">
			<el-tabs type="border-card" @tab-click="albumTypeChange" v-model="albumTab">
				<el-tab-pane label="图片上传" name="uploadFile">
					<el-upload
						name="album"
						ref="fileupload"
						list-type="picture-card"
						:show-file-list="true"
						:action="HOST + '/admin.document/uploadMultiFile'"
						:data="{
							adminid: JSON.parse($store.state.user.userInfo).id,
							token: JSON.parse($store.state.user.userInfo).token,
							name: attrname,
							iswaterimg: iswaterimg,
							iszoom: iszoom,
							zoomfirst:zoomfirst
						}"
						:auto-upload="false"
						accept=".jpg,.png,.jpeg,.gif"
						:multiple="type == 'multi' ? true : false"
						:http-request="uploadPicFile"
					>
						<i class="el-icon-plus"></i>
					</el-upload>
					<el-row style="margin-top: 15px;">
						<el-col :span="3">水印设置</el-col>
						<el-col :span="16">
							<el-radio-group v-model="iswaterimg">
								<el-radio :label="1">添加水印</el-radio>
								<el-radio :label="0">不添加水印</el-radio>
							</el-radio-group>
						</el-col>
					</el-row>
					<!-- <el-row style="margin-top: 15px;">
						<el-col :span="3">缩略图设置</el-col>
						<el-col :span="16">
							<el-radio-group v-model="iszoom">
								<el-radio :label="1">生成缩略图</el-radio>
								<el-radio :label="0">不生成缩略图</el-radio>
							</el-radio-group>
						</el-col>
					</el-row>
					<el-row style="margin-top: 15px;" v-if="iszoom">
						<el-col :span="3">优先展示</el-col>
						<el-col :span="16">
							<el-radio-group v-model="zoomfirst">
								<el-radio :label="1">缩略图</el-radio>
								<el-radio :label="0">原图</el-radio>
							</el-radio-group>
						</el-col>
					</el-row> -->
				</el-tab-pane>
				<el-tab-pane label="在线图片" name="chooseLineFile">
					<template v-if="type == 'multi'">
						<el-checkbox-group v-model="checkedLinePics">
							<el-checkbox v-for="(pic, index) in linePics" :key="index" :label="pic.file_src">
								<img :src="HOST + pic.file_src" :title="pic.file_title" :alt="pic.file_title" style="width: 150px;height: 150px;" />
							</el-checkbox>
						</el-checkbox-group>
					</template>
					<div class="grid" v-else style="grid-column-gap: 40px;">
						<div class="grid-item" v-for="(pic, index) in linePics" :key="index">
							<img
								:label="pic.file_filename"
								:src="HOST + pic.file_src"
								:title="pic.file_title"
								:alt="pic.file_title"
								style="width: 150px;height: 150px;"
								@click="chooseLinePic(pic)"
							/>
							<p>{{pic.file_title}}</p>
						</div>
					</div>

					<div class="block">
						<el-pagination
							@current-change="albumCurrentChange"
							:current-page="thispage"
							layout="total, sizes, prev, pager, next, jumper"
							:total="total"
							:page-sizes="[28]"
						></el-pagination>
					</div>
				</el-tab-pane>
			</el-tabs>
			<div slot="footer" class="dialog-footer text-center">
				<el-button type="success" @click="chooseAlbumConfirm">确 定</el-button>
				<el-button type="warning" @click="closeAlbumDialog">关闭窗口</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
export default {
	name: '',
	data() {
		return {
			albumDialogShow: false,
			linePics: [],
			checkedLinePics: [],
			albumTab: 'uploadFile', //本地上传，chooseLineFile在线图片
			thispage: 1,
			total: 0,
			linepic_refresh: false,
			uploadedLength: 0,
			waitUploadLength: 0,
			iswaterimg: 0, //是否生成水印
			iszoom: 0 ,//是否生成缩略图
			zoomfirst:0,//是否优先展示缩略图
			i: 0,
			formDate: '',
		};
	},
	props: {
		type: {
			type: String,
			default: 'one' //单选one 多选multi
		},
		attrname: {
			type: String,
			default: '' //单选one 多选multi
		},
		appendtobody:{
			type:Boolean,
			default:false
		}
	},
	mounted() {},
	methods: {
		show(attr) {
			console.log('传过来的参数:',attr);
			this.iszoom = attr=='pic'?1:0;
			console.log('是否需要缩略图:',this.iszoom);
			this.albumDialogShow = true;
		},
		albumTypeChange(e) {
			console.log(e.name);
			if (e.name == 'chooseLineFile') {
				if (!this.linePics.length || this.linepic_refresh) {
					this.getLinePics();
				}
			}
		},
		getLinePics() {
			this.$axios({
				url: this.HOST + '/admin.document/getLinePics',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
					thispage: this.thispage,
					pagesize: 28
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						if (res.data.admin_err == 'admininfo_error') {
							this.$message.error(res.data.msg);
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.linePics = res.data.data;
						this.total = res.data.total;
					}
				})
				.catch(err => {});
		},
		//在线图片页码翻页
		albumCurrentChange(val) {
			// console.log(`当前页: ${val}`);
			this.thispage = val;
			this.getLinePics();
		},
		closeAlbumDialog() {
			this.albumDialogShow = false;
			this.checkedLinePics = [];
		},
		// 重写文件合并上传函数
		uploadPicFile(file) {
			this.formDate.append('file' + this.i, file.file);
			this.i++;
		},
		chooseAlbumConfirm() {
			console.log(this.checkedLinePics);
			if (this.albumTab == 'chooseLineFile') {
				if (!this.checkedLinePics.length) {
					this.albumDialogShow = false;
					return false;
				}
				this.$emit('confirm', { type: 'multi', files: this.checkedLinePics });
				this.checkedLinePics = [];
				this.albumDialogShow = false;
			} else if (this.albumTab == 'uploadFile') {
				// this.$refs.albumUpload.submit();
				this.formDate = new FormData();
				this.$refs.fileupload.submit();
				let userinfo = JSON.parse(this.$store.state.user.userInfo);
				this.formDate.append('adminid', userinfo.id);
				this.formDate.append('token', userinfo.token);
				this.formDate.append('name', this.attrname);
				this.formDate.append('iswaterimg', this.iswaterimg);
				this.formDate.append('iszoom', this.iszoom);
				this.formDate.append('zoomfirst', this.zoomfirst);
				let config = {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				};
				this.$axios
					.post(this.HOST + '/admin.document/uploadMultiFile', this.formDate, config)
					.then(res => {
						console.log(res);
						if (res.data.status == 0) {
							this.$message.error(res.data.msg);
							if (res.data.admin_err == 'admininfo_error') {
								this.exit().then(res => {
									console.log(res);
									if (res.actionStatus == 1) {
										this.$router.push('/login');
									}
								});
							}
						} else if (res.data.status == 1) {
							this.$message.success(res.data.msg);
							if(this.type == 'multi'){
								this.$emit('confirm', { type: this.type, files: res.data.files,zoomfiles:res.data.zoomfiles });
							}else{
								this.$emit('confirm', { type: this.type, files: res.data.files[0],zoomfiles:res.data.zoomfiles[0] });
							}
							this.$refs.fileupload.clearFiles();
							this.albumDialogShow = false;
						}
					})
					.catch(res => {
						console.log(res);
					});
			}
		},
		// 选择在线图片
		chooseLinePic(pic) {
			console.log(pic);
			this.$emit('confirm', { type: 'single', files: pic.file_src });
			this.albumDialogShow = false;
		},
	}
};
</script>
<style lang="scss">
.grid {
	display: grid;
	grid-template-columns: repeat(auto-fill, 150px);
	grid-gap: 15px;
	.grid-item {
		position: relative;
		width: 150px;
		height: 150px;
		overflow: hidden;
		text-align: center;
		p {
			position: absolute;
			width: 100%;
			height: 28px;
			line-height: 28px;
			background: rgba($color: #207d26, $alpha: 0.5);
			color: #ffffff;
			bottom: 0;
		}
		img {
			width: 150px;
			height: 150px;
			border-radius: 5px;
		}
	}
}
.pic-dialog{
	.el-checkbox-group {
		display: grid;
		grid-template-columns: repeat(auto-fill, 175px);
		grid-gap: 15px;
		.el-checkbox {
			position: relative;
			width: 175px;
			height: 175px;
			overflow: hidden;
			text-align: center;
			p {
				position: absolute;
				width: 100%;
				height: 28px;
				line-height: 28px;
				background: rgba($color: #207d26, $alpha: 0.5);
				color: #ffffff;
				bottom: 0;
			}
			img {
				width: 150px;
				height: 150px;
				border-radius: 5px;
			}
		}
	}
}

</style>
